import { useCallback } from 'react';

import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { showShareModal } from '@/components';
import { usePlayUrl } from '@/shared/hooks';

interface UseShareHandlerParams {
  quizData: QuizSetDetailsRes;
}

/**
 * useShareHandler - 공유하기 핸들러
 *
 * @description
 * 퀴즈 공유 모달을 표시합니다.
 */
export const useShareHandler = ({ quizData }: UseShareHandlerParams) => {
  const playUrl = usePlayUrl(quizData.entryMapHashId);

  return useCallback(() => {
    showShareModal({
      ...quizData,
      shareUrl: playUrl,
      contentType: 'QUIZSET',
      contentId: quizData.id,
      contentOwnerId: quizData.authorId,
      spaceHashId: quizData.spaceHashId,
      trackLocation: 'detail',
    });
  }, [quizData, playUrl]);
};
